import LightHomePage from '../containers/LightHomePage/LightHomePage';
import ContactPage from '../containers/ContactPage/ContactPage';
import MenuPage from '../containers/MenuPage/MenuPage';
import GalleryPage from '../containers/GalleryPage/GalleryPage';
import NotFound from '../containers/NotFound/NotFound';
import Checkout from '../containers/CheckoutPage/CheckoutPage';
import ConfirmationPage from '../containers/ConfirmationPage/ConfirmationPage';
import TermsPage from '../containers/TermsPage/TermsPage';
import ReviewsPage from '../containers/ReviewsPage/ReviewsPage';
import TableBookingPage from '../containers/TableBooking/TableBookingPage';
import NewsletterUnsubscribe from '../containers/NewsletterUnsubscribe/NewsletterUnsubscribe';
import {reRenderOnResize} from '../containers/ResizeHandler/ResizeHandler';
import NewsletterSubscribe from '../containers/NewsletterUnsubscribe/NewsletterSubscribe';
import FeedbackPage from '../containers/FeedbackPage/Feedback';

export const lightRoutes = [
  {
    path: '/',
    exact: true,
    component: LightHomePage
  },
  {
    path: '/menu',
    component: reRenderOnResize(MenuPage)
  },
  {
    path: '/reorder/:orderId',
    component: reRenderOnResize(MenuPage)
  },
  {
    path: '/voucher/:code',
    component: reRenderOnResize(MenuPage)
  },
  {
    path: '/offlineMenu/:offlineMenuId',
    component: reRenderOnResize(MenuPage)
  },
  {
    path: '/gallery',
    component: GalleryPage
  },
  {
    path: '/reviews',
    component: ReviewsPage
  },
  {
    path: '/contact',
    component: ContactPage
  },
  {
    path: '/booking',
    component: TableBookingPage
  },
  {
    path: '/order/:basketUuid',
    exact: true,
    component: reRenderOnResize(Checkout)
  },
  {
    path: '/order/:orderId/confirmation',
    component: ConfirmationPage
  },
  {
    path: '/feedback/:orderId/:feedbackId',
    component: FeedbackPage
  },
  {
    path: '/terms',
    component: TermsPage
  },
  {
    path: '/newsletterUnsubscribe',
    component: NewsletterUnsubscribe
  },
  {
    path: '/newsletterSubscribe',
    component: NewsletterSubscribe
  },
  {
    path: '/404',
    component: NotFound
  },
  {
    component: NotFound
  }
];



// WEBPACK FOOTER //
// ./routes/light.config.js